import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'hot-air-balloon',
  size: 24,
  node: [
    ['path', { d: 'M11.5 18C10 15 9 12 9 9a3 7 0 0 1 6 0c0 3-1 6-2.5 9', key: 'kp3qpo' }],
    ['path', { d: 'M15 18c3-3 5-5 5-9A8 7 0 0 0 4 9c0 4 2 6 5 9', key: 'dn6qp0' }],
    ['path', { d: 'M15 18H9v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1z', key: 'j2zuhx' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name HotAirBalloon
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEuNSAxOEMxMCAxNSA5IDEyIDkgOWEzIDcgMCAwIDEgNiAwYzAgMy0xIDYtMi41IDkiIC8+CiAgPHBhdGggZD0iTTE1IDE4YzMtMyA1LTUgNS05QTggNyAwIDAgMCA0IDljMCA0IDIgNiA1IDkiIC8+CiAgPHBhdGggZD0iTTE1IDE4SDl2M2ExIDEgMCAwIDAgMSAxaDRhMSAxIDAgMCAwIDEtMXoiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/hot-air-balloon
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HotAirBalloon = createLucideIcon(__iconData);

export default HotAirBalloon;
